import axios from 'axios'
const API_URL = process.env.VUE_APP_API_URL;

class ProfiloService{
    async getScadenze(token, codiceCliente){
    
        return axios({
            url: API_URL + 'scadenzario/GetSacdenzarioCliente',
            method: "get",          
            headers:{
              Authorization: 'Bearer '+ token,
              'Content-Type': 'application/json'
            },     
            params: {
                codiceCliente: codiceCliente
            }
        })
        .then(
            data =>  {               
                if(data.status == 401){
                    return null;
                }
                else{
                    return data.data;
                }               
            }
        )
        .catch(error => {return error;});   
      }

}
export default new ProfiloService();